<!--Main Layout-->
<main>
    <div class="container">
        <div class="row mt-5 pt-md-5 mb-sm-5">
            <div class="col-sm-12">
                <div class="registerpet-pg">
                    <h1>Lag bruker</h1>
                </div>
            </div>

            <div class="col-sm-12">
                <div class="registerforpet-form">
                    <h1>Sted og dato funnet</h1>

                    <div class="width-100 mb-5">
                        <div class="form-feilds">
                            <label>{{ 'Pet Image | translate'}}</label>
                            <div class="upload-petsphoto">
                                <div class="muliple-photos">
                                    <input type="file" id="img" name="img" accept="image/*">
                                    <span class="fil-upload"><img src="assets/img/plus-icn.svg"
                                            class="img-fluid"></span>

                                </div>
                                <div class="muliple-photos d-none d-sm-block">
                                    <input type="file" id="img" name="img" accept="image/*">
                                    <span class="fil-upload"><img src="assets/img/plus-icn.svg"
                                            class="img-fluid"></span>
                                </div>
                                <div class="muliple-photos d-none d-sm-block">
                                    <input type="file" id="img" name="img" accept="image/*">
                                    <span class="fil-upload"><img src="assets/img/plus-icn.svg"
                                            class="img-fluid"></span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="width-100 mb-5">
                        <div class="form-feilds mb-3">
                            <label>Sted</label>
                            <input type="text" class="form-control" placeholder="Tast inn adresse" />
                        </div>
                        <div class="d-flex width-100 form-feilds">
                            <div class="custom-city mr-2">
                                <input type="text" class="form-control" placeholder="Poststed" />
                            </div>
                            <div class="custom-zipcode ml-2">
                                <input type="text" class="form-control" placeholder="Postnummer" />
                            </div>
                        </div>
                    </div>


                    <div class="width-100 mb-5">
                        <div class="form-feilds">
                            <label>Dato</label>
                        </div>
                        <div class="date-details form-feilds d-sm-flex">
                            <div class="width-100 d-flex mb-3">
                                <div class="day-details custom-mr">
                                    <select class="form-control">
                                        <option>Dag</option>
                                        <option>Dag 2</option>
                                        <option>Dag 3</option>
                                    </select>
                                </div>
                                <div class="day-details custom-mx">
                                    <select class="form-control">
                                        <option>Måned</option>
                                        <option>Måned 2</option>
                                        <option>Måned 3</option>
                                    </select>
                                </div>
                            </div>
                            <div class="width-100 d-flex">
                                <div class="day-details custom-mr">
                                    <select class="form-control">
                                        <option>År</option>
                                        <option>År 2</option>
                                        <option>År 3</option>
                                    </select>
                                </div>
                                <div class="day-details d-block d-sm-none">
                                    <input type="text" placeholder="I dag" class="form-control" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <h1 class="mb-3">Beskrivelse av kjæledyr</h1>

                    <div class="width-100 mb-3">
                        <div class="form-feilds mb-3">
                            <label class="d-none d-sm-block">Tittel</label>
                            <input type="text" class="form-control" placeholder="Eks. Hund/katt, farge, kjennetegn" />
                        </div>
                    </div>

                    <div class="width-100 mb-2">
                        <div class="form-feilds mb-2">
                            <label>Type kjæledyr</label>
                            <select class="form-control">
                                <option>Type</option>
                                <option>Type1</option>
                            </select>
                        </div>
                    </div>

                    <div class="width-100 mb-5">
                        <div class="gender-dec">
                            <div class="colors-pet">
                                <div class="form-feilds mb-2">
                                    <label class="d-none d-sm-block">Farge</label>
                                    <select class="form-control">
                                        <option>Farge</option>
                                        <option>Farge</option>
                                        <option>Farge</option>
                                    </select>
                                </div>

                                <div class="form-feilds d-block d-sm-none">
                                    <label class="d-none d-sm-block">Kjønn</label>
                                    <select class="form-control">
                                        <option>Kjønn</option>
                                        <option>Kjønn</option>
                                        <option>Kjønn</option>
                                    </select>
                                </div>

                            </div>
                            <div class="gender-pet d-none d-sm-block">
                                <div class="form-feilds ">
                                    <label>Kjønn</label>
                                    <div class="pets-gender">
                                        <div class="custom-radio">
                                            <label for="html">Hunn</label>
                                            <input type="radio" id="Hunn" name="" value="Hunn" class="form-control">
                                             
                                        </div>
                                        <div class="custom-radio">
                                            <label for="html">Han</label>
                                            <input type="radio" id="Hunn" name="" value="Hunn" class="form-control">
                                             
                                        </div>
                                        <div class="custom-radio">
                                            <label for="html">Vet ikke</label>
                                            <input type="radio" id="Hunn" name="" value="Hunn" class="form-control">
                                             
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="width-100 mb-5">

                        <div class="form-feilds mb-3">
                            <label class="d-none d-sm-block">Beskrivelse</label>
                            <label class=" d-block d-sm-none">Ytterligere beskrivelse</label>
                            <textarea class="form-control cus-texthgi" rows="140" cols="50"
                                placeholder="Skriv litt om dyrets tilstand, utseende og kjennetegn"></textarea>
                        </div>


                    </div>

                    <h1 class="mb-3">Din kontaktinfo</h1>

                    <div class="width-100 mb-0">
                        <div class="details-name">
                            <div class="custom-name">
                                <div class="form-feilds mb-3">
                                    <label>Navn</label>
                                    <input type="text" class="form-control" placeholder="Navn" />
                                </div>
                            </div>
                            <div class="custom-lname">
                                <div class="form-feilds mb-3">
                                    <label class="d-none d-sm-block">Etternavn</label>
                                    <input type="text" class="form-control" placeholder="Etternavn" />
                                </div>
                            </div>

                        </div>

                    </div>

                    <div class="width-100 mb-0">
                        <div class="details-name">
                            <div class="custom-name">
                                <div class="form-feilds mb-3">
                                    <label>Navn</label>
                                    <input type="text" class="form-control" placeholder="Navn" />
                                </div>
                            </div>
                            <div class="custom-lname">
                                <div class="form-feilds mb-3">
                                    <label class="d-none d-sm-block">Etternavn</label>
                                    <input type="text" class="form-control" placeholder="Etternavn" />
                                </div>
                            </div>

                        </div>

                    </div>

                    <div class="width-100 mb-3">

                        <div class="form-feilds mb-3">
                            <label class="d-none d-sm-block">E-post adresse</label>
                            <input type="text" class="form-control" placeholder="Navn" />
                        </div>
                    </div>


                    <div class="width-100 mb-5">
                        <div class="form-feilds mb-3">
                            <label>Sted</label>
                            <input type="text" class="form-control" placeholder="Gatenavn" />
                        </div>
                        <div class="d-flex width-100 form-feilds">
                            <div class="zipcode mr-2">
                                <input type="text" class="form-control" placeholder="Postnummer" />
                            </div>
                            <div class="custom-zipcode ml-2">
                                <input type="text" class="form-control" placeholder="Poststed" />
                            </div>
                        </div>
                    </div>

                    <div class="width-100 mb-5 d-block d-sm-none">
                        <div class="form-feilds ">
                            <label>Jeg kan kontaktes på</label>
                            <div class="check-epost">
                                <div class="custom-radio">
                                    <div class="round">
                                        <input type="checkbox" id="checkbox1" />
                                        <label for="checkbox1"></label>
                                    </div>
                                    <span class="label">Telefon</span>
                                     
                                </div>
                                <div class="custom-radio">
                                    <div class="round">
                                        <input type="checkbox" id="checkbox2" />
                                        <label for="checkbox2"></label>
                                    </div>
                                    <span class="label">E-post</span>
                                     
                                </div>


                            </div>
                        </div>
                    </div>



                </div>
            </div>



        </div>





        <div class="row mb-5">

            <div class="col-sm-12">
                <div class="details-registr">
                    <button type="button" class="btn btn-green">Send inn <span><i class="fas fa-arrow-right"></i>
                        </span></button>
                </div>
            </div>
        </div>

    </div>
</main>